import { createContext, PropsWithChildren, useEffect, useState } from "react";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { v4 } from 'uuid'

type ScreenContextType = {
    width: number;
    isMobile: boolean;

}
const ScreenContext = createContext<ScreenContextType | null>(null);

ScreenContext.displayName = "ScreenContext";

type ScreenProviderProps = {

}

export function ScreenProvider({ children }: PropsWithChildren<ScreenProviderProps>) {

    const [width, setWidth] = useState<number>(window.screen.width);

    const location = useLocation();

    useEffect(() => {
        window.addEventListener('resize', (e) => {
            setWidth(window.screen.width)
        })
    }, [])

    useEffect(() => {
        setWidth(window.screen.width)
    }, [location])

    const isMobile = width < 768;

    return (
        <ScreenContext.Provider value={{
            width,
            isMobile
        }}
        >
            {children}
        </ScreenContext.Provider>
    )
};

export function useScreen() {
    const value = useContext(ScreenContext);

    if (!value) {
        throw new Error('useScreen must be wrapped in a <ScreenProvider />');
    }

    return value;
}


export default ScreenProvider